module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#f3f3f3",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-header"
  }, [(_vm.logoProviderConfirmation === '') ? _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._v("CondoPlaza")])])]) : _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.logoProviderConfirmation,
    attrs: {
      "src": _vm.logoProviderConfirmation,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "progrees-line",
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color": "red",
      "background-color": "white"
    }
  })], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center call-cupom"
  }, [_c('strong', [_vm._v("Entendemos a sua decisão.")])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center call-cupom texto"
  }, [_vm._v("\n        Muito obrigado!\n        ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c25ee6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cancelarEnvio/cancelarEnvio.vue
// module id = 736
// module chunks = 36